/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Theme, useTheme } from 'bold-ui'
import { SideMenuSublink } from 'components/side-menu-navegation/SideMenuSublink'
import { useState } from 'react'
import { Accordion } from 'react-accessible-accordion'

import { AcompanhamentoMenuTitle, getAcompanhamentosSideMenuItems } from '../hooks/getAcompanhamentosSideMenuItems'
import { AcompanhamentosSideMenuItem } from './AcompanhamentosSideMenuItem'

export function AcompanhamentosSideMenu() {
  const [selectedMenu, setSelectedMenu] = useState<AcompanhamentoMenuTitle>()
  const menuItems = getAcompanhamentosSideMenuItems()

  const theme = useTheme()
  const styles = createStyles(theme)

  const handleMenuClick = (title: AcompanhamentoMenuTitle) => {
    title === selectedMenu ? setSelectedMenu(undefined) : setSelectedMenu(title)
  }

  return (
    <aside css={styles.aside}>
      <Accordion allowZeroExpanded css={css(styles.accordion)}>
        {menuItems.map((item) => (
          <AcompanhamentosSideMenuItem
            title={item.title}
            isMenuActive={selectedMenu === item.title}
            onClickMenuItem={() => handleMenuClick(item.title)}
            key={item.title}
            icon={item.icon}
            alt={item.alt}
            color={item.color}
          >
            {item.subItems.map((subItem) => (
              <SideMenuSublink
                to={subItem.to}
                key={subItem.title}
                title={subItem.title}
                sublinkStyle={css`
                  &.active {
                    color: ${item.color.c40};
                  }
                `}
              />
            ))}
          </AcompanhamentosSideMenuItem>
        ))}
      </Accordion>
    </aside>
  )
}

const createStyles = (theme: Theme) => ({
  aside: css`
    padding: 0;
    width: 100%;
    border: 0;
    height: auto;
    overflow: visible;
  `,

  accordion: css`
    border: 1px ${theme.pallete.gray.c60} solid;
  `,
})
